export default __webpack_public_path__ + "static/media/3.814fcd40.jpeg";